module.exports = false;



//////////////////
// WEBPACK FOOTER
// /app/SPA/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1